import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { router } from './routes';
import './styles/globals.css';

const rootElement = document.getElementById('root') as HTMLElement | null;
if (!rootElement) {
  throw new Error('Root element not found');
}

if (rootElement.dataset.seoStatic !== '1') {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </React.StrictMode>
  );
}
